import CopyBlock from './CopyBlock'

const LSI = [
  'vector design fee',
  'brand identity matrix',
  'Dieter Rams legacy',
  'grid-based geometry',
  'skeuomorphic design history',
  'Braun app icon',
]

function GuidesBlocks() {
  return (
    <div className="space-y-6">
      {/* Educational article: logo for / of calculator */}
      <article className="rounded-2xl border border-white/8 bg-[#0b1020] p-6 shadow-xl shadow-black/40 md:p-8">
        <h3 className="font-display text-2xl font-bold text-white">
          The Logo of the Calculator: From Braun to Skeuomorphic iOS
        </h3>
        <p className="mt-3 leading-relaxed text-slate-400">
          When people search for the "logo of calculator" or "logo for calculator," they are often
          tracing a design lineage that runs from the{' '}
          <span className="text-emerald-400">Dieter Rams legacy</span> at Braun straight into the
          original skeuomorphic iOS calculator app icon. Rams' ET66 calculator — with its rounded
          keys and disciplined grid — became the visual blueprint Apple later referenced.
        </p>
        <div className="mt-5 grid gap-4 md:grid-cols-2">
          <div className="rounded-xl border border-white/8 bg-white/[0.02] p-4">
            <h4 className="font-display text-sm font-semibold text-indigo-300">
              H3 · Grid-based geometry
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
              Calculator marks rely on disciplined grids: equal key spacing, optical alignment, and a
              modular rhythm that survives at favicon scale.
            </p>
          </div>
          <div className="rounded-xl border border-white/8 bg-white/[0.02] p-4">
            <h4 className="font-display text-sm font-semibold text-indigo-300">
              H3 · Skeuomorphic legacy
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
              Early app icons mimicked physical buttons and shadows — a memetic shortcut that made the
              calculator instantly recognizable across billions of devices.
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {LSI.map((term) => (
            <span
              key={term}
              className="rounded-full border border-white/8 bg-white/[0.03] px-3 py-1 font-mono text-xs text-slate-300"
            >
              {term}
            </span>
          ))}
        </div>
      </article>

      {/* One-click copy marketing templates */}
      <div className="grid gap-4 md:grid-cols-2">
        <CopyBlock
          label="Meta · logo pricing calculator"
          text="Logo Pricing Calculator: instantly estimate agency and freelance logo fees by expertise tier, labor hours, revisions, market index, and licensing rights. Free, transparent, itemized quotes."
        />
        <CopyBlock
          label="Meta · logo calculator"
          text="Logo Calculator: solve safe margins, aspect ratios, and golden-ratio geometry for pixel-perfect brand marks. Live preview included — no sign-up, no downloads."
        />
        <CopyBlock
          label="Meta · vans logo calculator"
          text="Vans Logo Calculator: discover why the Off The Wall mark is secretly the square root of ANS. Generate your own √ skateboard formula and learn how memetic branding goes viral."
        />
        <CopyBlock
          label="Meta · estimation logo"
          text="Logo Estimation made simple: get a fast, data-backed branding cost estimate tailored to your scope, market, and usage rights. Start your logo estimation in seconds."
        />
        <CopyBlock
          label="H1 concept · main capture"
          text="Logo Calculator — Estimate Pricing, Aspect Ratios & Vector Geometry"
        />
        <CopyBlock
          label="Content brief · neon gallery"
          text="Showcase black, white, and neon calculator logo variations with a visual style guide covering contrast, scalability, and dark-mode reversibility for modern brand systems."
        />
      </div>
    </div>
  )
}

export default GuidesBlocks
